module.exports = __webpack_public_path__ + "static/sport/loginactive.18a1342.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/loginactive.png
// module id = CU/y
// module chunks = 0